import {
  ConversationAiMarkModel,
  ConversationAiResourcesEnum,
  ConversationAiStatusesEnum,
} from '../../models/api/conversationAiMarkModel';
import {ConversationModel} from '../../models/api/conversationModel';

export interface AiReview {
  status: ConversationAiStatusesEnum.APPROVED | ConversationAiStatusesEnum.DISCARDED;
  resourceId: number | undefined;
}

export function filterAiMarkForConversation(
  conversation: ConversationModel,
  resourceType: ConversationAiResourcesEnum,
  status: ConversationAiStatusesEnum,
): ReadonlyArray<ConversationAiMarkModel> {
  return conversation.aiMarks?.filter((m) => m.resourceType === resourceType && m.status === status) ?? [];
}
